export default __webpack_public_path__ + "static/media/SP_5.f4032cbc.PNG";